var scrollNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-scroll-nav]',
		fixtoWrapper: '[data-fixto-wrapper]'
	}

	scrollNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new ScrollNav(el);
		});
	}

	class ScrollNav {
		constructor(element) {
			this.nav = element;

			this.init();
			this.resize();
			this.bind();


		}
		init() {

			this.links = $('a[href^="#"]:not([href="#"])', this.nav);

			if ($(this.nav).closest(selectors.fixtoWrapper).length) {
				this.fixto = fixto.fixTo(this.nav, $(this.nav).closest(selectors.fixtoWrapper).get(0), {
					top: window.scrollOffset ? window.scrollOffset : 0,
					useNativeSticky: false
				});
			}

			this.targets = [];
			this.links.each((i, link) => {

				var $target = $($(link).attr('href'));

				if ($target.length) {
					this.targets.push({
						el: $target.get(0),
						link: link,
						offset: $target.offset().top
					});
				}

			});
		}
		resize() {
			$(this.targets).each((i, targetData) => {
				targetData.offset = $(targetData.el).offset().top
			});

			this.targets.sort((a, b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0));

		}
		bind() {

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });

			$(window).scroll((e) => { this.scroll(); });

			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });

			$(this.links).click((e) => { this.linkClicked($(e.target).closest('a').get(0)); })
		}

		scroll() {

			if (this.isScrolling) return;

			const winOffset = $(window).width() >= 900 ? 140 : 70;

			var _this = this;

			// console.log("#######");

			$(this.targets).each((i, targetData) => {

				var scrollOff = $(window).scrollTop() + winOffset + 1;

				var is_active = scrollOff >= targetData.offset;

				if (i < _this.targets.length - 1 && scrollOff >= _this.targets[i + 1].offset)
					is_active = false;

				if (is_active) {
					$(targetData.link).addClass('is-active');
				}
				else {
					$(targetData.link).removeClass('is-active');
				}

			});

		}

		linkClicked(link) {
			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
		}

	}

})(jQuery);


export default scrollNavInit;